import { FormikHelpers } from "formik";

import { useContext } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { isTypeOfUserInspectorSearchForm } from "src/components/Common/UI/SydFilter/SydFilterTypeChecker";
import UserInspectorSearchForm from "./UserInspectorSearchForm";

const emptyUserInspectorSearchForm: IUserInspectorSearchForm = {
  datetimeFrom: "",
  datetimeTo: "",
  username: ""
};

const SearchUserInspector = ()  => {
  const sydFilterCtx = useContext(SydFilterContext);

  const activeFilters = sydFilterCtx.activeFilters;
  const clearForm = sydFilterCtx.clearAllFilters;
  const saveFilters  = sydFilterCtx.saveFilters;
  const handleClose = sydFilterCtx.toggleFilterVisibility;

  const initialValues = isTypeOfUserInspectorSearchForm(activeFilters) ? activeFilters as IUserInspectorSearchForm : emptyUserInspectorSearchForm;

  const handleSubmit = async (values: IUserInspectorSearchForm, { setSubmitting }: FormikHelpers<IUserInspectorSearchForm>): Promise<void> => {
    saveFilters(values);
    setSubmitting(false);
    handleClose();
  }

  return (
    <UserInspectorSearchForm initialValues={initialValues} onSubmit={handleSubmit} onClearForm={clearForm} /> 
  )
}


export default SearchUserInspector;